import Vue from 'vue';

const notProduction = process.env.NODE_ENV !== 'production';

// initial state
const state = {
	currentPage: '',
	showPagination: true,
	hasLine: true,
	isSmall: false,
	fullHeight: true,
	showNav: false,
	outOfViewPos: '',
	fullWidthUntilLg: false,
	fowardLoop: true,
	backwardLoop: true,
	itemMinWidth: 'big',
};

// actions
const actions = {
	makeFullScreen({commit}) {
		commit('updateData', {
			name: 'itemMinWidth',
			value: 'big',
		});
		commit('updateData', {
			name: 'showNav',
			value: false,
		});
		setTimeout(() => {
			commit('updateData', {
				name: 'isSmall',
				value: false,
			});
			commit('updateData', {
				name: 'hasLine',
				value: true,
			});
			commit('updateData', {
				name: 'fullHeight',
				value: true,
			});
		}, 300);
	},	
	hideRightAndThenMakeFullScreen({commit, dispatch}) {
		commit('updateData', {
			name: 'outOfViewPos',
			value: 'right',
		});
		setTimeout(() => {
			dispatch('makeFullScreen');
		}, 1000);
	},	
	makeFullScreenAndHideRight({dispatch}) {
		dispatch('hideRight');
		dispatch('makeFullScreen');
	},
	setupPagination({commit}) {
		commit('updateData', {
			name: 'isSmall',
			value: true,
		});
		commit('updateData', {
			name: 'hasLine',
			value: false,
		});
		commit('updateData', {
			name: 'fullHeight',
			value: false,
		});
		setTimeout(() => {
			commit('updateData', {
				name: 'itemMinWidth',
				value: 'small',
			});
			commit('updateData', {
				name: 'showNav',
				value: true,
			});
		}, 300);
	}
};

// mutations
const mutations = {
	updateData(state, payload) {
		if (notProduction) {
			console.log(payload.name, payload.value);
		}
		Vue.set(state, payload.name, payload.value);
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};


// WEBPACK FOOTER //
// ./assets/_js/store/modules/pagination.js